/**
 * File: singleActivityReport.js
 * Project: educore
 * Created Date: 2019-01-29
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import html2canvas from 'html2canvas';
class reportsMainCtrl {
    // @ngInject
    constructor($scope, $state, $rootScope, authService, localStorageService,
        UserPrivilages, TPWIZARDCONSTANT, $stateParams, activityCons, SchoolLogo,
        CONSTANTS, $sce, OPTIONAL_SCHOOLFONTS) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            getPrivileges()
        }
        let userId = localStorageService.get("user_id")
        let userAccess = _.filter(localStorageService.get("feature_privileges"), function(feature) {
            return feature.module_state == "activityList"
        })
        $scope._is_creator = false
        $scope.activityUserPrivilege = {};
        function getPrivileges(){
            try{
                if (userAccess.length > 0) {
                    _.each(userAccess, function(tpObj) {
                        let user_access = {};
                        _.each(tpObj.privilege, function(privObj) {
                            user_access[privObj.name.toLowerCase()] = privObj.status
                        })
                        $scope.activityUserPrivilege[tpObj.feature_id] = user_access;
                    })
                }
            }catch(e){
                console.log(e)
            }
            
        }
        function checkPrivilegeToUpdate(result){
            try{
                if($scope.activityUserPrivilege && $scope.activityUserPrivilege.createActivity &&
                    $scope.activityUserPrivilege.createActivity.create && result &&
                    result.teacher_id && result.teacher_id == userId){
                        $scope._is_creator = true
                }
            }catch(e){
                console.log(e)
            }
        }
        $scope.studentList = localStorageService.get('students_this_class')
        let is_staff = localStorageService.get("is_staff")
        //On destroy function
        this.$onDestroy = () => { }
        //String - Question paper id
        let qpId = $state.params.qpId;
        var authoring = localStorageService.get('authoringData')
        var schoolId = authoring.school_id
        var academicYear = authoring.academic_year
        // $scope.isLoading = true
        $scope.pdfData = false
        //[Object] - Contains chart data
        $scope.chartArray = []
        $scope.chartImages = {}
        $scope.chartImages.mcqs = []
        //Number - To set width of chart
        $scope.chartWidth = 1000;

        //Number - To set height of chart
        $scope.chartHeight = 500;

        //[Object] - Holds list of chart details
        $scope.chartImgData = []

        $scope.colorArray = ['#3366cc', '#f59f00', '#109618']

        //[Object] - Holds list of chart details
        $scope.chartImgData = []

        //[Object] - chart availability
        $scope.chartAvailability = {
            isQuesVsStudent: false
        }
        $scope.quesCount = 0
        $scope.studCount = 0
        $scope.studAttendCount = 0
        $scope.absentees = 0
        $scope.canview_class_avg = true
        $scope.afl_extra_info = {}
        function graphrange_values() {
            google.charts.load('current', { packages: ['corechart', 'bar'] });
            google.charts.setOnLoadCallback(drawRangeValues);
        }
        function drawRangeValues() {
            let data = google.visualization.arrayToDataTable($scope.range_values)

            let options = {
                // title: 'Population of Largest U.S. Cities',
                chartArea: { width: '50%' },
                hAxis: {
                    title: 'Score in percentage',
                    minValue: 0,
                    textStyle: {
                        bold: true,
                        fontSize: 14,
                        color: '#4d4d4d'
                    },
                    titleTextStyle: {
                        bold: true,
                        fontSize: 14,
                        color: '#4d4d4d'
                    }
                },

                vAxis: {
                    title: 'Number Of Students',
                    textStyle: {
                        fontSize: 14,
                        bold: true,
                        color: '#848484'
                    },
                    titleTextStyle: {
                        fontSize: 14,
                        bold: true,
                        color: '#848484'
                    }
                },
                legend: {
                    position: 'none'
                }
            };
            let chart = new google.visualization.ColumnChart(document.getElementById('range_values'));
            google.visualization.events.addListener(chart, 'ready', function () {
                $scope.chartImages.score_percent = chart.getImageURI();
            })
            chart.draw(data, options);
        }
        // */
        function graphavg_per_theme() {
            google.charts.load('current', { packages: ['corechart', 'bar'] });
            google.charts.setOnLoadCallback(drawAvdPerTheme);
        }
        function drawAvdPerTheme() {
            let data = google.visualization.arrayToDataTable($scope.avg_per_theme)
            var options = {

                title: 'Theme Wise Performance %',
                legend: {
                    position: 'none'
                },
                vAxis: {
                    title: 'Themes'
                },
                hAxis: {
                    minValue: 0
                }
            };
            // if($scope.avg_per_theme.length > 6){
            options['width'] = 600
            // options['height'] = 400
            options['chartArea'] = { left: '50%', right: "10%" }
            // }
            let chart = new google.visualization.BarChart(document.getElementById('avg_per_theme'));
            google.visualization.events.addListener(chart, 'ready', function () {
                $scope.chartImages.avg_per_theme = chart.getImageURI();
            })
            chart.draw(data, options);
        }
        function drawPieChart() {
            var data = google.visualization.arrayToDataTable($scope.pie);


            let colorsArray = []
            if ($scope.pie.length) {
                for (let i = 1; i < $scope.pie.length; i++) {
                    colorsArray.push($scope.pie[i][2])
                }
            }
            var options = {
                title: 'Grade Distribution',
                // width:'50px',
                colors: colorsArray,
                pieSliceText: ['none'],
                //   chartArea:{left:1,top:6,width:"100%",height:"100px"}
            };
            var chart = new google.visualization.PieChart(document.getElementById('pie'));
            google.visualization.events.addListener(chart, 'ready', function () {
                $scope.chartImages.pie = chart.getImageURI();
            })
            chart.draw(data, options);
        }
        function graphPie() {
            google.charts.load('current', { 'packages': ['corechart'] });
            google.charts.setOnLoadCallback(drawPieChart);
        }
        function setHeader(data) {
            if (data) {
                $scope.quesCount = data.question_data.count
                $scope.studCount = data.qp_data.students
                $scope.studAttendCount = data.qp_data.atended
                $scope.absentees = data.qp_data.students - data.qp_data.atended
                $scope.activity_name = data.qp_data.question_paper_title
                $scope.authoring = authoring
                $scope.schoollogo = CONSTANTS.FILE_UPLOAD_URL + data.school_data.logo
                $scope.schoolName = data.school_data.school_name
                if (OPTIONAL_SCHOOLFONTS.CANTERBURY_FONT_SCHOOLS.indexOf(data.school_data._id) !== -1) {
                    $scope.canterburySchools = true
                }
            } else {
                let obj = {
                    quesCount: $scope.quesCount,
                    studCount: $scope.studCount,
                    studAttendCount: $scope.studAttendCount,
                    absentees: $scope.absentees,
                    activity_name: $scope.activity_name,
                    authoring: $scope.authoring
                }
                return obj
            }


        }
        $scope.isLoading = true
        $scope.showGraphs = false
        function initLoad() {

            $scope.url = undefined;
            authService.callAPI("/v0/assesment-report/class/report", "POST", {
                qp_id: qpId, school_id : schoolId,'FILE_UPLOAD_URL' : CONSTANTS.FILE_UPLOAD_URL
            }, function (response) {
                try {
                    let data = response.result.data.details.response
                    checkPrivilegeToUpdate(data)
                    $scope.range_values = data.range_values
                    $scope.avg_per_theme = data.avg_per_theme
                    $scope.result_per_mcq = data.result_per_mcq.returnObj
                    $scope.first_set_MCQ = data.result_per_mcq.first_set_MCQ
                    $scope.qbDocuments = data.result_per_mcq.qbDocuments
                    $scope.performance = data.highest_average
                    $scope.pie = data.pie
                    $scope.secondObj = data.result_per_mcq.secondObj
                    $scope.allMcq = data.result_per_mcq.allMcq
                    setHeader(data.header)
                    if(data.resultsAllStudents && data.resultsAllStudents.length){
                        $scope.showGraphs = true
                        graphrange_values()
                        graphavg_per_theme()
                    }
                    $scope.afl_extra_info = data.afl_extra_info ? data.afl_extra_info : {}
                    
                    
                    google.charts.load('current', { packages: ['corechart', 'bar'] });
                    google.charts.setOnLoadCallback(redefinedMCQ)

                    graphPie()
                } catch (e) {
                    console.log(e)
                }
                
                $scope.isLoading = false
                $scope.$apply()
            })
        }
        
        if(!is_staff){
            $state.go("activityList")
        }else{
            $scope.isLoading = true
            initLoad()
        }
        function mcqSetQuestions() {
            google.charts.load('current', { packages: ['corechart', 'bar'] });


            let questionIds = Object.keys($scope.allMcq)
            $scope.MCQs = []
            $scope.questionTitleArray = []

            for (let [index, one] of questionIds.entries()) {
                let exq = _.find($scope.qbDocuments, function (oneq) {
                    return oneq._id == one
                })
                if (exq && exq.qn_desc) {
                    $scope.questionTitleArray.push({
                        qn_desc: exq.qn_desc, isLatex: exq.isLatex
                    })
                }
                $scope.MCQs.push($scope.allMcq[one])
                // $('#chart-main-div').append('<div flex="20" id="result_per_mcq' + index + '"  style="width:45%;height: 220px;"></div>');

            }

        }
        function redefinedMCQ() {
            mcqSetQuestions()
            let firstDocLength = 5;
            let docLength = 12;
            $scope.mcqGroupData = [];
            $scope.allMcqCount = $scope.MCQs
            let groupLength = Math.ceil(($scope.allMcqCount.length - firstDocLength) / docLength) + 1;
            for (let i = 0; i < groupLength; i++) {
                if (i) {

                    $scope.mcqGroupData.push({
                        _id: i,
                        mcqGroupData: $scope.allMcqCount.slice(((i - 1) * docLength) + firstDocLength, ((i * docLength) + firstDocLength))
                    });
                } else {
                    $scope.mcqGroupData.push({
                        _id: i,
                        mcqGroupData: $scope.allMcqCount.slice(0, firstDocLength)
                    });
                }
            }
            $scope.$apply();
            let aliQuestion = 0
            $scope.chartImages.mcqs = []
            for (let j = 0; j < $scope.mcqGroupData.length; j++) {
                
                for (let i = 0; i < $scope.mcqGroupData[j].mcqGroupData.length; i++) {
                    let generatedId = 'result_per_mcq' + j + '_' + i;
                    let str = '<div flex="20" id="' + generatedId + '" style="width:45%;height: 220px;"></div>'
                    if ($scope.questionTitleArray[aliQuestion].isLatex) {
                        str = '<div class="question_desc" flex="20" id="' + generatedId + '" style="width:45%;height: 220px;"></div>'
                    }
                    $('#group_' + j).append(str);
                    let idStr = generatedId
                    let options = {
                        // title: 'Population of Largest U.S. Cities',
                        title: "Q",
                        title: "Q" + (aliQuestion + 1) + ": " + $scope.questionTitleArray[aliQuestion].qn_desc,
                        chartArea: { width: '50%' },
                        hAxis: {

                            minValue: 0,
                            textStyle: {
                                bold: true,
                                fontSize: 12,
                                color: '#4d4d4d'
                            },
                            titleTextStyle: {
                                bold: true,
                                fontSize: 18,
                                color: '#4d4d4d'
                            }
                        },
                        vAxis: {
                            minValue: 0,
                            title: '% Of Students',
                            textStyle: {
                                fontSize: 14,
                                bold: true,
                                color: '#848484'
                            },
                            titleTextStyle: {
                                fontSize: 14,
                                bold: true,
                                color: '#848484'
                            }
                        },
                        legend: {
                            position: 'none'
                        }
                    };
                    let chart = new google.visualization.ColumnChart(document.getElementById(generatedId));
                    let data = google.visualization.arrayToDataTable($scope.mcqGroupData[j].mcqGroupData[i]);
                    google.visualization.events.addListener(chart, 'ready', function () {
                        $scope.chartImages.mcqs.push(chart.getImageURI());
                    })
                    chart.draw(data, options);
                    aliQuestion++
                }

            }
            // setMCQ()
        }
        function setMCQ() {
            setTimeout(() => {
                let MQ = MathQuill.getInterface(2);
                let questionElements = document.getElementsByClassName('question_desc')
                _.each(questionElements, function (spanElement) {
                    MQ.StaticMath(spanElement);
                })
            })
        }
        authService.callAPI(activityCons.API_GET_SCHOOL_DETAILS + schoolId, "POST", {}, (response) => {
            if (response.result && response.result.status && response.result.data.details) {
                let result = response.result.data.details
                $scope.schoolHeader = {
                    'schoolName': result.school_name,
                    'schoolLogo': SchoolLogo.checkLogo(CONSTANTS.FILE_UPLOAD_URL + result.logo),
                    'academicYear': academicYear
                }
                convertFileToDataURLviaFileReader($scope.schoolHeader.schoolLogo, function (base64Image) {
                    $scope.imgurl1 = base64Image;
                })
            }
        })



        $scope.barOptions = {
            responsive: true,
            scaleBeginAtZero: true,
            scaleShowGridLines: false,
            barValueSpacing: 1,
            barDatasetSpacing: 1,
            tooltipEvents: ["mousemove", "mouseout", "click", "touchstart", "touchmove", "touchend"],
            legend: {
                display: false,
            },
            scales: {
                xAxes: [{
                    barPercentage: 0.9,
                    categoryPercentage: 0.5
                }],
                yAxes: [{
                    ticks: {
                        stepSize: 1,
                        beginAtZero: true // minimum value will be 0.
                    }
                }]
            },
        }

        /*
         * Function to go back to activity page
         *
         * @return - null
         *
         */
        $scope.goBack = () => {
            $state.go("activityReports")
        }

        function convertFileToDataURLviaFileReader(url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function () {
                var reader = new FileReader();
                reader.onloadend = function () {
                    callback(reader.result);
                }
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        };

        /*
         * To get chart details from Child chart component
         * 
         * @data : Object - Chart details
         * 
         * @return : null
         */
        $scope.getChartData = function (data) {
            if (data != undefined && data[0] != undefined) {
                $scope.chartImgData.push(data[0])
            }
        }
        $scope.exportAsPDF = function () {
            try {
                $scope.pdfLoading = true
                html2canvas(document.querySelector("#container_main")).then(mainCon => {
                    try {
                        var maindoc = new jsPDF('p', 'pt', 'a4', false);

                        let maintableImageProps = maindoc.getImageProperties(mainCon.toDataURL("image/png"));
                        let mainheightThisCanvas = maintableImageProps.height;

                        let str = $scope.authoring.class + "-" + $scope.authoring.batch +
                            "-" + $scope.authoring.subject + "-" + $scope.activity_name

                        html2canvas(document.querySelector("#acitivity-per-data")).then(canvas => {
                            try {
                                var doc = new jsPDF('p', 'pt', 'a4', false);
                                var width = doc.internal.pageSize.getWidth();
                                var height = doc.internal.pageSize.getHeight();
                                // let tableImageProps = doc.getImageProperties(canvas.toDataURL("image/png"));
                                // let height = tableImageProps.height;
                                doc.addImage(canvas.toDataURL("image/png"), 'png', 0, 10, width, height - 500, undefined, 'none');
                                let oneFullContent = 0
                                if (!$scope.mcqGroupData.length) {
                                    doc.save(str + '.pdf');
                                    $scope.pdfLoading = false
                                    $scope.$apply();
                                    return false
                                }
                                for (let i = 0; i < $scope.mcqGroupData.length; i++) {
                                    html2canvas(document.querySelector('#group_' + i)).then(eachGroup => {
                                        try {
                                            let yAxis = 200;
                                            let chartHeight = 400;
                                            let tableImageProps = doc.getImageProperties(eachGroup.toDataURL("image/png"));
                                            let len = $scope.mcqGroupData[i].mcqGroupData.length
                                            let heightThisCanvas = tableImageProps.height;
                                            if (i) {
                                                yAxis = 10;
                                                doc.addPage();
                                                chartHeight = chartHeight + 300
                                                if (len < 12) {
                                                    if (i == $scope.mcqGroupData.length - 1) {
                                                        if (!oneFullContent) {
                                                            oneFullContent = heightThisCanvas
                                                        }
                                                        chartHeight = chartHeight - oneFullContent
                                                        chartHeight = chartHeight + 25
                                                    } else {
                                                        oneFullContent = heightThisCanvas
                                                        chartHeight = chartHeight - eachGroup.height + yAxis
                                                    }
                                                }
                                            } else {
                                                yAxis = 380
                                                let len = $scope.mcqGroupData[i].mcqGroupData.length
                                                if (len < 5) {
                                                    chartHeight = heightThisCanvas - yAxis
                                                }
                                            }
                                            doc.addImage(eachGroup.toDataURL('image/png'), 'png', 10, yAxis, width - 20, chartHeight);

                                        } catch (ex2) {
                                            console.log(ex2)
                                        }
                                    });
                                }
                                setTimeout(() => {
                                    doc.save(str + '.pdf');
                                    $scope.pdfLoading = false
                                    $scope.$apply();
                                }, 20000);
                                // doc.setFontSize(5);
                                // doc.text((width / 2) - 20, height - 10, 'page 1');
                                // doc.save(str + '.pdf')

                            } catch (ex1) {
                                console.log(ex1)
                            }
                        });
                    } catch (e) {
                        console.log(e)
                    }
                })

            } catch (ex) {
                $scope.pdfLoading = false
                $scope.$apply();
                console.log(ex)
            }
        }
        /*
         * To export chart as PDF file
         * 
         * @return : null
         */
        // $scope.exportAsPDF = function () {
        //     var doc = new jsPDF('p', 'pt', 'a4', false) /* Creates a new Document*/
        //     doc.addImage($scope.imgurl1, 'png', 50, 30, 70, 70, undefined, 'none');
        //     doc.setFontSize(18);
        //     doc.setFontType('bold');
        //     var xOffset = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth($scope.schoolHeader.schoolName) * doc.internal.getFontSize() / 2);
        //     doc.text(xOffset, 50, $scope.schoolHeader.schoolName);
        //     doc.setFontSize(12);
        //     doc.setFontType('normal');
        //     doc.text(230, 70, 'Academic Year : ' + $scope.schoolHeader.academicYear);
        //     doc.setFontSize(16);
        //     doc.text(220, 90, 'Activity Based Report');
        //     doc.setFontSize(15); /* Define font size for the document */
        //     var yAxis = 150;

        //     for (var i = 0; i < $scope.chartImgData.length; i++) {
        //         if (i % 2 == 0 && i != 0) { /* I want only two images in a page */
        //             doc.addPage(); /* Adds a new page*/
        //             yAxis = 30; /* Re-initializes the value of yAxis for newly added page*/
        //         }

        //         var width = doc.internal.pageSize.width; //$scope.imageTags[i].width;
        //         var height = $scope.chartImgData[i].height - 100; //doc.internal.pageSize.height;

        //         if (doc.internal.pageSize.width <= $scope.chartImgData[i].width) {
        //             width = doc.internal.pageSize.width;
        //         } else {
        //             width = $scope.chartImgData[i].width;
        //         }

        //         height = $scope.chartImgData[i].height * width / doc.internal.pageSize.width;
        //         height = width * (3 / 4) - 100

        //         var someText = (i + 1) + ".) " + $scope.chartImgData[i].title;
        //         doc.text(60, yAxis, someText); /* Add some text in the PDF */
        //         yAxis = yAxis + 20; /* Update yAxis */
        //         //doc.addImage($scope.imageTags[i].image, 'png', 40, yAxis, 530, 350, undefined, 'none');
        //         doc.addImage($scope.chartImgData[i].image, 'png', 0, yAxis, width, height, undefined, 'none');
        //         yAxis = yAxis + 360; /* Update yAxis */
        //     }
        //     window.open(doc.output('bloburl'))
        //     // doc.save('Activity_Based_Report.pdf')
        // }
        $scope.backToHtml = () => {
            $scope.pdfData = false
            $scope.isLoading = true
            initLoad()
        }
        $scope.exportQuestionWiseReport = () => {
            $scope.isPdfData = true
            $scope.url = $sce.trustAsResourceUrl($scope.urls)
        }
        $scope.htmlDivReport = function () {
            try {
                return $sce.trustAsHtml($scope.reportData.htmlStr);
            } catch (e) {
                console.log(e)
            }

        }
        // authService.callAPI('/v0/qp-reports/cognitive-skills/performance', "POST", {
        //     qp_id : qpId,
        //     my_user_id : localStorageService.get('user_id'),
        //     FILE_UPLOAD_URL : CONSTANTS.FILE_UPLOAD_URL
        // }, function(response) {
        //     try{
        //         $scope.reportData = response.result.data.details.response
        //         $scope.urls = $scope.reportData.pdf_url
        //    console.log(response)
        //     }catch(e){
        //         console.log(e)
        //     }
        // })
        $scope.gotoStudentReport = (id) => {
            // $state.go("individualStudentTraditionalReportCtrl", {
            //     student_id: id,
            //     qpId: qpId
            // })
            $state.go("activitypersstudentCtrl", {
                student_id: id,
                qp_id: qpId,
                page: 1
            })
        }
        
        $scope.exportFromServer = () => {
            // console.log($scope.chartImages)
            $scope.pdfData = true
            let obj = {}
            $scope.loading = false
            $scope.isLoading = true
            obj['headers'] = setHeader(false)
            obj['charts'] = $scope.chartImages
            obj['headers']['performance'] = $scope.performance
            obj['headers']['schoolName'] = $scope.schoolName
            obj['headers']['schoolHeader'] = $scope.schoolHeader
            obj['headers']['schoollogo'] = $scope.schoollogo
            
            obj.canterburySchools  = $scope.canterburySchools
            obj['FILE_UPLOAD_URL'] = CONSTANTS.FILE_UPLOAD_URL
            obj.qp_id = qpId,
            obj.school_id = schoolId,
            authService.callAPI("/v0/assesment-report/export/class/report", "POST", obj, function (response) {
                try {
                    
                    if (response.result) {
                        
                        let data = response.result.data.details.response
                        // console.log(data)
                        $scope.url = $sce.trustAsResourceUrl(data)
                        
                        
                        
                    }
                } catch (e) {
                    console.log(e)
                }
                $scope.loading = false
                $scope.isLoading = false
                $scope.$apply();
            })

        }
        $scope.extra_info_error = {}
        $scope.saveExtraInfoInExams= () => {
            let err_cnt = 0
            $scope.extra_info_error = {}
            if(!$scope.afl_extra_info){
                toastr.error("Please enter teacher analysis or remedial measure")
                return false
            }
            if(!$scope.afl_extra_info.teacher_analysis && !$scope.afl_extra_info.remedial_measure){
                toastr.error("Please enter teacher analysis or remedial measure")
                return false
            }
            if($scope.afl_extra_info.teacher_analysis){
                let len = $scope.afl_extra_info.teacher_analysis.length
                if(len > 250){
                    $scope.extra_info_error.teacher_analysis = {}
                    $scope.extra_info_error.teacher_analysis['message'] = "Please enter text less than 250 characters"
                    err_cnt++
                }
            }
            if($scope.afl_extra_info.remedial_measure){
                let len = $scope.afl_extra_info.remedial_measure.length
                if(len > 250){
                    $scope.extra_info_error.remedial_measure = {}
                    $scope.extra_info_error.remedial_measure['message'] = "Please enter text less than 250 characters"
                    err_cnt++
                }
            }
            if(err_cnt){
                return false
            }
            let obj = {
                qp_id: qpId,
                school_id : schoolId,
                afl_extra_info : $scope.afl_extra_info
            }
            authService.callAPI("/v0/assesment-report/class/report/save/extrainfo", "POST",
                obj, function (response, error) {
                    if(!response.error){
                        // $scope.afl_extra_info
                        // $scope.studentScore.afl_extra_info = {
                        //     teacher_analysis : $scope.afl_extra_info.teacher_analysis,
                        //     remedial_measure : $scope.afl_extra_info.remedial_measure
                        // }
                        toastr.success("Remarks saved")
                    }
                    $scope.$apply()
            })
        }
        
    };
}

export default reportsMainCtrl;


// WEBPACK FOOTER //
// ./src/app/traditionalActivity/controllers/reports-main.js